import produce from 'immer';
import { FETCH_REVISIONS_ATTEMPTED, FETCH_REVISIONS_FAILED, FETCH_REVISIONS_SUCCEEDED } from '../actions/ActionTypes';
const revisionHistoryReducer = (state = {
  results: [],
  total: 0,
  offset: 0,
  limit: 0,
  requestStatus: null
}, {
  type,
  response
}) => produce(state, draft => {
  switch (type) {
    case FETCH_REVISIONS_ATTEMPTED:
      {
        draft.requestStatus = 'LOADING';
        return draft;
      }
    case FETCH_REVISIONS_SUCCEEDED:
      {
        if (response.offset === 0) {
          response.requestStatus = 'SUCCEEDED';
          return response;
        }
        draft.results = draft.results.concat(response.results);
        draft.offset = response.offset;
        draft.limit = response.limit;
        draft.total = response.total;
        draft.requestStatus = 'SUCCEEDED';
        return draft;
      }
    case FETCH_REVISIONS_FAILED:
      draft.requestStatus = 'FAILED';
      return draft;
    default:
      return draft;
  }
});
export default revisionHistoryReducer;